import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, rgba, getResetByTag } from '../../../styles';
import StyledButton from '../../button/button-new.styles';
var buttonStyles = function buttonStyles() {
  return /*#__PURE__*/css("&:active,&:focus,&:hover{border-radius:0;}&:hover{background:", colors.white, ";}&:focus{background:transparent;box-shadow:", rem(0, 0, 0, 4), " ", colors.blue_500, ";}&:active{background:transparent;box-shadow:inset ", rem(0, 4, 4, 0), " ", rgba(0, 0, 0, 0.2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:buttonStyles;"));
};
var resetStyles = getResetByTag(StyledButton);
var StyledAlertButton = /*#__PURE__*/_styled(StyledButton, process.env.NODE_ENV === "production" ? {
  target: "eubu5750"
} : {
  target: "eubu5750",
  label: "StyledAlertButton"
})(resetStyles, buttonStyles);
export default StyledAlertButton;